import { Link } from "react-router-dom"
import "../css/Certs.css"

const Certs = () => {

    const certs = [
        {
            name: "UNE-EN ISO 9001",
            image: "/images/SGC.png",
            file: "/certs/ISO-9001-2024.pdf"
        },
        {
            name: "UNE-EN ISO 14001",
            image: "/images/SGM.png",
            file: "/certs/ISO-14001-2024.pdf"
        },
        {
            name: "RD 311/2022",
            image: "/images/ENS-ALTA.png",
            file: "/certs/ENS-ALTA.pdf"
        }
    ]

    return (
        <main id="certs">
            <h1>Certificaciones</h1>
            <p>Desde <strong>Spica S.L.</strong> estamos comprometidos con todos nuestros clientes y con el medioambiente, por ello contamos con las certificaciones oportunas en materia de calidad,medio ambiente y seguridad.</p>

            <section className="flex jevenly" id="certification_downloads">
                {certs.map((cert, i) => {
                    return (
                        <article key={i}>
                            <img src={cert.image} alt={cert.name} />

                            <p>{cert.name}</p>

                            <Link to={cert.file} target="_blank">
                                <button>Descargar el certificado</button>
                            </Link>
                        </article>
                    )
                })}
            </section>

        </main>
    )
}
export default Certs
